import React, { useState, useEffect } from "react";
import "./appointmentReport.css";
import NarrowDropdown2 from "../../../components/input/new/narrowDropdown2";
import { useSelector } from "react-redux";
import Header from "../../components/header";
import NarrowDropdownHierarchy from "../../../components/input/new/narrowDropdownHierarchy";

const LOCATIONS = ["All", "Office (Video Visit)", "Office (In‑person Visit)"];
const STATUS = ["All", "Confirmed", "Unconfirmed", "Canceled"];
const SOURCES = ["All", "Online", "Phone", "Referral"];
const APPT_TYPES = ["All", "Consultation", "Follow‑Up", "Emergency"];
const CLIENT_TYPES = ["All", "New", "Returning"];
const DATE_RANGES = [
  "Since last statement",
  "This month",
  "Last 30 days",
  "Custom",
];

export default function AppointmentReport() {
  const [professionals, setProfessionals] = useState([]);
  const [selectedLawyers, setSelectedLawyers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [inviteError, setInviteError] = useState(null);
  const firmId = useSelector(
    (state) => state.attorneyData.attorneyData?.firm_id
  );

  useEffect(() => {
    async function loadProfessionals() {
      try {
        const res = await fetch(
          `/api/attorney/fetchFirmMembers?firm_id=${firmId}`
        );
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Fetch failed");
        setProfessionals(data.lawyers);
        setSelectedLawyers(data.lawyers.map((l) => l.user_id));
      } catch (err) {
        console.error(err);
        setInviteError("Failed to load professionals.");
      } finally {
        setIsLoading(false);
      }
    }
    if (firmId) loadProfessionals();
  }, [firmId]);

  const [filters, setFilters] = useState({
    professional: "John Brown",
    location: "All",
    status: "All",
    source: "All",
    apptType: "All",
    clientType: "All",
    dateRange: "Since last statement",
  });

  const stats = {
    confirmed: 0,
    unconfirmed: 0,
    reschedules: 0,
    firmCancels: 0,
    clientCancels: 0,
    noShows: 0,
  };

  const appointments = [];

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header />

      <div className="report-container">
        <div className="filters-container">
          <div className="filters-toolbar second-row">
            <NarrowDropdownHierarchy
              title="Professional"
              placeholder="All"
              items={professionals.map((p) => ({
                label: p.name,
                value: p.name,
              }))}
              value={filters.professional}
              onChange={(v) => setFilters((f) => ({ ...f, professional: v }))}
            />
            <NarrowDropdownHierarchy
              title="Location"
              placeholder="All"
              items={LOCATIONS.map((l) => ({ label: l, value: l }))}
              value={filters.location}
              onChange={(v) => setFilters((f) => ({ ...f, location: v }))}
            />
            <NarrowDropdownHierarchy
              title="Status"
              placeholder="All"
              items={STATUS.map((s) => ({ label: s, value: s }))}
              value={filters.status}
              onChange={(v) => setFilters((f) => ({ ...f, status: v }))}
            />
            {/* <div
              className="filter-reset"
              onClick={() =>
                setFilters({
                  professional: "All",
                  location: "All",
                  status: "All",
                  source: "All",
                  apptType: "All",
                  clientType: "All",
                  dateRange: "Since last statement",
                })
              }
            >
              Reset All
            </div> */}
          </div>

          <div className="filters-toolbar second-row">
            <NarrowDropdownHierarchy
              title="Source"
              placeholder="All"
              items={SOURCES.map((s) => ({ label: s, value: s }))}
              value={filters.source}
              onChange={(v) => setFilters((f) => ({ ...f, source: v }))}
            />
            <NarrowDropdownHierarchy
              title="Appointment Type"
              placeholder="All"
              items={APPT_TYPES.map((t) => ({ label: t, value: t }))}
              value={filters.apptType}
              onChange={(v) => setFilters((f) => ({ ...f, apptType: v }))}
            />
            <NarrowDropdownHierarchy
              title="Client Type"
              placeholder="All"
              items={CLIENT_TYPES.map((t) => ({ label: t, value: t }))}
              value={filters.clientType}
              onChange={(v) => setFilters((f) => ({ ...f, clientType: v }))}
            />
          </div>
        </div>

        <div className="report-header">
          <h2>
            Appointment Report since last statement ({"4/1/25 – 4/21/25"})
          </h2>
          <div className="download-group">
            <NarrowDropdown2
              placeholder="Since last statement"
              items={DATE_RANGES.map((r) => ({ label: r, value: r }))}
              value={filters.dateRange}
              onChange={(v) => setFilters((f) => ({ ...f, dateRange: v }))}
            />
            <button className="csv-btn">Download .csv</button>
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-item">
            <span className="stat-label">Confirmed appointments</span>
            <span className="stat-value">{stats.confirmed}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Unconfirmed appointments</span>
            <span className="stat-value">{stats.unconfirmed}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Firm reschedules</span>
            <span className="stat-value">{stats.reschedules}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Firm cancellations</span>
            <span className="stat-value">{stats.firmCancels}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Client cancellations</span>
            <span className="stat-value">{stats.clientCancels}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Client no-shows</span>
            <span className="stat-value">{stats.noShows}</span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "50px 100px",
          }}
        >
          <table className="appointments-table">
            <thead>
              <tr>
                <th>Professional</th>
                <th>Client</th>
                <th>Appointment time</th>
                <th>Source</th>
                <th>Appointment Type</th>
                <th>Client Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {appointments.length === 0 ? (
                <tr className="no-data">
                  <td colSpan="8" style={{ height: "100px" }}>
                    No appointments during this time period
                  </td>
                </tr>
              ) : (
                appointments.map((a, i) => (
                  <tr key={i}>
                    <td>{a.professional}</td>
                    <td>{a.client}</td>
                    <td>{a.time}</td>
                    <td>{a.source}</td>
                    <td>{a.type}</td>
                    <td>{a.clientType}</td>
                    <td>{a.status}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
